import React from "react";
import withUser from "../hoc/withUser";
import { withRouter } from "react-router-dom";
import {
  Button,
  TextField,
  Snackbar,
  SnackbarContent
} from "@material-ui/core";
import WarningIcon from "@material-ui/icons/Warning";
import classNames from "classnames";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import { white } from "../styles/color";
import moment from "moment";

const variantIcon = {
  warning: WarningIcon
};

const styles1 = theme => ({
  warning: {
    backgroundColor: theme.palette.error.dark
  },
  icon: {
    fontSize: 20
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing.unit
  },
  message: {
    display: "flex",
    alignItems: "center"
  }
});

function MySnackbarContent(props) {
  const { classes, className, message, onClose, variant, ...other } = props;
  const Icon = variantIcon[variant];

  return (
    <SnackbarContent
      className={classNames(classes[variant], className)}
      aria-describedby="client-snackbar"
      message={
        <span id="client-snackbar" className={classes.message}>
          <Icon className={classNames(classes.icon, classes.iconVariant)} />
          {message}
        </span>
      }
      {...other}
    />
  );
}

MySnackbarContent.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  message: PropTypes.node,
  onClose: PropTypes.func,
  variant: PropTypes.oneOf(["warning"]).isRequired
};

const MySnackbarContentWrapper = withStyles(styles1)(MySnackbarContent);
const stylesMain = theme => ({
  margin: {
    margin: "8px"
  },
  textField: {
    flexBasis: 200
  }
});
class AddOrganisation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      organisationName: "",
      openSnackBar: false,
      date: moment(new Date()).format("YYYY-MM-DD")
    };
  }

  handleChange = name => event => {
    this.setState({ [name]: event.target.value });
  };
  handleOpenSnackBar = () => {
    this.setState({ openSnackBar: true });
  };

  handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    this.setState({ openSnackBar: false });
  };
  render() {
    const { addOrganisation, organisations, classes } = this.props;
    const { organisationName, date } = this.state;
    return (
      <div
        style={{
          height: "100vh",
          backgroundImage:
            "url('background.jpg'), linear-gradient(#ff4e00, #ec9f05)",

          backgroundBlendMode: "multiply",
          backgroundRepeat: "round",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignContent: "center"
        }}
      >
        <TextField
          id="outlined-bare"
          name="organisationName"
          onChange={this.handleChange("organisationName")}
          margin="normal"
          variant="outlined"
          label="Enter Organisation Name"
          className={classNames(classes.margin)}
          autoComplete="off"
          InputLabelProps={{
            shrink: true,
            style: { color: white }
          }}
          inputProps={{
            style: { color: white }
          }}
        />
        <Button
          size="small"
          style={{ color: white }}
          onClick={e => {
            e.preventDefault();
            if (this.state.organisationName && this.props.user.uid !== "") {
              const organisation = {
                organisationName: organisationName,
                createdBy: this.props.user.uid,
                createdAt: new Date(),
                serialNumber: 0
              };
              addOrganisation(organisation);
              this.props.history.push("/deals");
            } else {
              this.handleOpenSnackBar();
            }
          }}
        >
          Add Organisation
        </Button>

        <Snackbar
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center"
          }}
          open={this.state.openSnackBar}
          autoHideDuration={3000}
          onClose={this.handleClose}
        >
          <MySnackbarContentWrapper
            variant="warning"
            message="Organisation Name Must Be Filled before Adding....!"
          />
        </Snackbar>
      </div>
    );
  }
}

export default withRouter(withUser(withStyles(stylesMain)(AddOrganisation)));
